import { ApplicationHeader } from '@zeiss/beyond-online-react';

interface PageLoaderHeaderProps {
  productTitle: string;
}
export const PageLoaderHeader = ({ productTitle }: PageLoaderHeaderProps) => {
  return (
    <ApplicationHeader
      applicationTitle={productTitle}
      logo={{}}
      shellLayout="with-side-nav"
    />
  );
};
